module.exports = __webpack_public_path__ + "media/images/health-line-6a4535a4da95fad9b156de856cdc410c.png";